<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      class="adaptationModal salesOrderEdit"
      :title="isCopy ? '销售订单复制' : disabled ? '详情' : sDSalesOrderVO.salesOrderId ? '编辑' : '新建'"
      width="1350px"
      @close="close()">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="sDSalesOrderVO"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <div class="editTitle">销售订单信息</div>
      <el-row>
        <el-col v-if="sDSalesOrderVO.salesOrderId" :span="8">
          <el-form-item label="订单编号" prop="salesOrderNo">
            <el-input v-model="sDSalesOrderVO.salesOrderNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="订单类型" prop="salesOrderCategory">
            <el-select
                v-model="sDSalesOrderVO.salesOrderCategory"
                placeholder="请选择订单类型"
                :disabled="sDSalesOrderVO.salesOrderId > 0"
                @change="salesOrderCategoryChange">
              <el-option label="销售订单" :value="10"/>
              <el-option label="赠送订单" :value="20"/>
              <el-option label="借用订单" :value="30"/>
              <el-option label="样品订单" :value="40"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户名称" prop="customerName">
            <el-input v-model="sDSalesOrderVO.customerName" readonly placeholder="请选择客户">
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  :disabled="sDSalesOrderVO.salesOrderId > 0"
                  @click="$refs.selectCustomerName.open()"/>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="付款方式" prop="paymentTypeId">
            <el-select v-model="sDSalesOrderVO.paymentTypeId" placeholder="请选择付款方式">
              <el-option v-for="item in payMethods" :key="item.pkId" :value="item.pkId" :label="item.paymentTypeName"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系人" prop="contact">
            <el-input v-model="sDSalesOrderVO.contact" placeholder="请输入联系人"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系方式" prop="telephone">
            <el-input v-model="sDSalesOrderVO.telephone" type="tel" maxlength="11" placeholder="请输入联系方式"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户合同号" prop="customerContractNo">
            <el-input v-model="sDSalesOrderVO.customerContractNo" placeholder="请输入客户合同号"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="所属区域" prop="districtIdCopy">
            <el-cascader
                v-model="sDSalesOrderVO.districtIdCopy"
                :options="options"
                style="width: 100%"
                placeholder="请选择所属区域"
                filterable/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="详细地址" prop="deliveryPlace">
            <el-input
                v-model="sDSalesOrderVO.deliveryPlace"
                placeholder="请选择详细地址"
                :disabled="!sDSalesOrderVO.customerId">
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  :disabled="!sDSalesOrderVO.customerId"
                  @click="$refs.addressSelect.open(sDSalesOrderVO.customerId)"/>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="交货日期" prop="deliveryDate">
            <el-date-picker
                v-model="sDSalesOrderVO.deliveryDate"
                value-format="yyyy-MM-dd"
                type="date"
                style="width: 100%"
                placeholder="选择交货日期"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="商务申请" prop="businessApplicationNo">
            <el-input
                v-model="sDSalesOrderVO.businessApplicationNo"
                placeholder="请选择商务申请"
                :disabled="!sDSalesOrderVO.customerId">
              <el-button
                  v-if="!sDSalesOrderVO.businessApplicationNo"
                  slot="append"
                  icon="el-icon-search"
                  :disabled="!sDSalesOrderVO.customerId"
                  @click="$refs.selectBusinessApplication.open(sDSalesOrderVO.customerId)"/>
              <el-button v-else slot="append" icon="el-icon-refresh" @click="resetHandle"/>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="ERP订单编号" prop="erpSalesOrderNo">
            <el-input v-model="sDSalesOrderVO.erpSalesOrderNo" placeholder="请输入ERP订单编号"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="项目名称" prop="projectName">
            <el-input v-model="sDSalesOrderVO.projectName" placeholder="请输入项目名称"/>
          </el-form-item>
        </el-col>
        <el-col v-if="sDSalesOrderVO.salesOrderId" :span="8">
          <el-form-item label="制单人" prop="creatorName">
            <el-input v-model="sDSalesOrderVO.creatorName" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="sDSalesOrderVO.salesOrderId" :span="8">
          <el-form-item label="制单时间" prop="createDate">
            <el-input v-model="sDSalesOrderVO.createDate" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="sDSalesOrderVO.salesOrderId" :span="8">
          <el-form-item label="状态" prop="statusName">
            <el-input v-model="sDSalesOrderVO.statusName" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="sDSalesOrderVO.salesOrderCategory===30" :span="8">
          <el-form-item label="归还日期" prop="statusName">
            <el-date-picker
                v-model="sDSalesOrderVO.returnDate"
                value-format="yyyy-MM-dd"
                type="date"
                style="width: 100%"
                placeholder="选择交货日期"/>
          </el-form-item>
        </el-col>
        <el-col v-if="sDSalesOrderVO.submitDate" :span="8">
          <el-form-item label="提交时间" prop="submitDate">
            <el-input v-model="sDSalesOrderVO.submitDate" disabled/>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="备注" prop="note">
            <el-input v-model="sDSalesOrderVO.note" type="textarea" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">销售订单物料</div>
      <div style="margin-bottom: 10px">
        <el-button type="primary" @click="$refs.selectMaterial.open('已上架')"> 添加物料</el-button>
        <el-button type="primary" @click="businessApplicationAdd"> 价格申请</el-button>
      </div>
      <el-table
          class="orderMaterials"
          :data="sDSalesOrderVO.materialVOS"
          border
          @select="select"
          @select-all="select">
        <el-table-column type="selection" align="center" width="40" prop="selection"/>
        <el-table-column align="center" type="index" label="#" width="50"/>
        <!-- <el-table-column prop="businessTypeName" label="业务类别" width="100" align="center"/> -->
        <el-table-column prop="materialTypeName" label="物料类型" width="100"/>
        <el-table-column align="center" prop="quantity" label="数量" width="100">
          <template slot-scope="scope">
            <el-input v-model="scope.row.quantity"/>
          </template>
        </el-table-column>
        <!--        <el-table-column align="center" prop="unitName" label="单位" width="70"/>-->
        <el-table-column align="center" prop="price" label="单价" width="130">
          <template slot-scope="scope">
            <el-input v-if="scope.row.price === null && disabled" v-model="scope.row.price" disabled placeholder="***"/>
            <el-input v-else v-model="scope.row.price"/>
          </template>
        </el-table-column>
        <el-table-column align="center" label="总价" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.price !== null">{{(scope.row.quantity * scope.row.price).toFixed(2)}}</span>
            <span v-else>***</span>
          </template>
        </el-table-column>
        <el-table-column label="交货日期" align="center" width="160">
          <template slot-scope="scope">
            <el-date-picker
                v-model="scope.row.deliveryDate"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                placeholder="请选择日期"/>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="nameplateType" label="铭牌属性" width="120">
          <template slot-scope="scope">
            <el-select v-model="scope.row.nameplateType">
              <el-option value="铭牌" label="铭牌"/>
              <el-option value="中性" label="中性"/>
              <el-option value="客户模板" label="客户模板"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="备注" width="250">
          <template slot-scope="scope">
            <el-input v-model="scope.row.note" class="note" type="textarea" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column label="发货备注" width="250">
          <template slot-scope="scope">
            <el-input v-model="scope.row.deliveryNote" class="note" type="textarea" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="materialNo" label="物料编号" min-width="120"/>
        <el-table-column prop="materialSpecification" label="规格型号" min-width="120"/>
        <el-table-column prop="materialName" label="物料名称" min-width="100"/>
        <el-table-column align="center" prop="customerPurchase" label="客户采购单号" width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.customerPurchase"/>
          </template>
        </el-table-column>
        <el-table-column prop="customerContractNoRow" label="客户合同号" width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.customerContractNoRow"/>
          </template>
        </el-table-column>
        <el-table-column prop="customerMaterialNo" label="客户料号" width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.customerMaterialNo"/>
          </template>
        </el-table-column>
        <el-table-column prop="customerSpecification" label="客户型号" width="160">
          <template slot-scope="scope">
            <el-input v-model="scope.row.customerSpecification"/>
          </template>
        </el-table-column>
        <el-table-column prop="finalCustomerSpecification" label="终端客户型号" width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.finalCustomerSpecification"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="80" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" @click="sDSalesOrderVO.materialVOS.splice(scope.$index, 1)"> 删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="editTitle" style="margin-top: 15px">销售订单附件</div>
      <div style="margin-bottom: 8px">
        <upload-file
            v-if="!disabled"
            ref="upload"
            :show-file-list="false"
            :auth-index="authIndex"
            @upload-success="uploadSuccess"/>
      </div>
      <el-table :data="sDSalesOrderVO.attachments" border>
        <el-table-column type="index" align="center" label="#" width="55"/>
        <el-table-column prop="fileName" align="left" label="附件描述" show-overflow-tooltip/>
        <el-table-column label="操作" width="120px" align="center">
          <template slot-scope="scope">
            <el-button v-if="downLoadAuth" :disabled="false" type="primary" @click="downLoad(scope.row)">下载</el-button>
            <el-button type="danger" @click="sDSalesOrderVO.attachments.splice(scope.$index, 1)"> 删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <handle-detail v-if="billId!=='0'" :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
    </el-form>
    <span slot="footer">
      <el-button @click="close()">取消</el-button>
      <el-button v-if="!disabled" type="primary" :loading="submitLoading" @click="handleSubmit">确定</el-button>
    </span>
    <customer-select ref="selectCustomerName" @select="selectCustomerName"/>
    <address-select ref="addressSelect" @select="addressSelect"/>
    <business-application-select ref="selectBusinessApplication" @select="selectBusinessApplication"/>
    <material-select ref="selectMaterial" @select="selectMaterial"/>
    <business-application-edit ref="businessApplicationEdit"/>
  </el-dialog>
</template>

<script>
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import AddressSelect from "@/views/information/Customer/CustomerAddressSelect";
  import BusinessApplicationSelect from "../businessApplication/BusinessApplicationSelect";
  import BusinessApplicationEdit from "../businessApplication/BusinessApplicationEdit";
  import MaterialSelect from "@/views/information/Material/MaterialSelect";
  import UploadFile from "@/components/UploadFile.vue";
  import HandleDetail from "@/views/workFlow/HandleDetail";

  export default {
    components: {
      CustomerSelect,
      BusinessApplicationSelect,
      MaterialSelect,
      UploadFile,
      AddressSelect,
      BusinessApplicationEdit,
      HandleDetail,
    },
    props: {
      options: {
        type: Array,
        default: () => {
          return [];
        },
      },
    },

    data() {
      return {
        billId: "0",
        billType: "1",
        downLoadAuth: this.$auth(369),
        authIndex: 369,
        selection: [],
        disabled: false,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        isCopy: 0,
        sDSalesOrderVO: {
          salesOrderId: 0,
          salesOrderCategory: 10,
          salesOrderNo: "",
          erpSalesOrderNo: "",
          customerContractNo: "",
          projectName: "",
          deliveryDate: "",
          customerId: "",
          customerName: "",
          contact: "",
          telephone: "",
          districtId: "",
          districtIdCopy: [],
          deliveryPlace: "",
          note: "",
          salesPriceBaId: "",
          businessApplicationNo: "",
          materialVOS: [],
          attachments: [],
          paymentTypeId: "",
        },
        payMethods: [],
        ruleValidate: {
          // customerContractNo: { required: true, message: "请输入客户合同号" },
          deliveryDate: {required: true, message: "请选择交货日期"},
          customerName: {required: true, message: "请选择客户"},
          returnDate: {required: true, message: "请选择归还日期"},
          contact: {required: true, message: "请输入联系人", trigger: "blur"},
          telephone: {required: true, message: "请输入联系方式", trigger: "blur"},
          deliveryPlace: {required: true, message: "请输入详细地址", trigger: "blur"},
          districtIdCopy: {required: true, message: "请选择所属区域"},
          paymentTypeId: {required: true, message: "请选择付款方式", trigger: "change"},
        },
        businessApplicationPrice: 0, // 商务申请审批价格
      };
    },

    methods: {
      open(row, isCopy, disabled) {
        this.dialogVisible = true;
        this.isCopy = isCopy;
        this.disabled = disabled;
        if (row) {
          this.billId = row.salesOrderId.toString();
          this.sDSalesOrderVO.salesOrderCategory = 10;
        }
        this.$nextTick(() => {
          this.getPaymentTypes();
          if (row) {
            this.getData(row.salesOrderId);
          }
        });
      },

      close() {
        this.dialogVisible = false;
        this.billId = "0";
        this.billType = "1";
        this.sDSalesOrderVO = {};
        this.$reset("form");
      },

      select(selection) {
        this.selection = selection;
      },

      // 选择客户
      selectCustomerName(row) {
        this.sDSalesOrderVO.customerId = row.customerID;
        this.sDSalesOrderVO.customerName = row.customerName;
        this.sDSalesOrderVO.contact = row.contact;
        this.sDSalesOrderVO.telephone = row.telephone;
        this.sDSalesOrderVO.paymentTypeId = row.paymentTypeId ? row.paymentTypeId : "";
        if (!this.sDSalesOrderVO.salesOrderId) {
          this.getAddress(row.customerID);
        }
      },
      //订单类型
      salesOrderCategoryChange() {
        console.log(this.sDSalesOrderVO.salesOrderCategory);
      },
      // 付款方式
      getPaymentTypes() {
        this.$http.get("basic", "paymentTypes").then((res) => {
          if (res.success) {
            this.payMethods = res.data;
          }
        });
      },

      // 附件下载
      downLoad(row) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(row.filePath)}`).then((res) => {
          if (res.success) {
            window.open(res.data);
          }
        });
      },

      getAddress(customerId) {
        this.$http.get("basic", `customers/${customerId}`).then((res) => {
          if (res.success) {
            const arr = res.data.customerDeliveryAddresses;
            if (arr.length) {
              let result = arr.find((item) => item.isDefault);
              if (result) {
                this.sDSalesOrderVO.districtIdCopy = result.districtId.split(",").map((item) => parseInt(item));
                this.sDSalesOrderVO.deliveryPlace = result.addressDetail;
              }
            } else {
              this.sDSalesOrderVO.districtIdCopy = [];
              this.sDSalesOrderVO.deliveryPlace = "";
            }
          }
        });
      },

      // 选择详细地址
      addressSelect(row) {
        this.sDSalesOrderVO.districtIdCopy = row.districtId.split(",").map((item) => parseInt(item));
        this.sDSalesOrderVO.districtId = this.sDSalesOrderVO.districtIdCopy.join();
        this.sDSalesOrderVO.deliveryPlace = row.addressDetail;
      },

      // 选择商务申请
      selectBusinessApplication(row) {
        this.sDSalesOrderVO.salesPriceBaId = row.businessApplicationID;
        this.sDSalesOrderVO.businessApplicationNo = row.businessApplicationNO;
        this.businessApplicationPrice = row.approve3Price;
        this.$http
            .post("basic", "sd/so/setPrice", this.sDSalesOrderVO)
            .then((resp) => {
              if (resp.success) {
                resp.data.materialVOS.forEach((item, index) => {
                  this.sDSalesOrderVO.materialVOS[index].standardPrice = item.standardPrice;
                  this.sDSalesOrderVO.materialVOS[index].price = item.price;
                });
              }
            })
            .catch(() => {
            });
      },

      resetHandle() {
        this.sDSalesOrderVO.salesPriceBaId = "";
        this.sDSalesOrderVO.businessApplicationNo = "";
        this.businessApplicationPrice = 0;
        if (this.sDSalesOrderVO.materialVOS.length) {
          this.sDSalesOrderVO.materialVOS.forEach((item) => {
            item.price = 0;
          });
        }
      },

      // 添加物料
      selectMaterial(row) {
        let obj = {
          customerId: this.sDSalesOrderVO.customerId,
          businessType: row.businessType,
          businessTypeName: row.businessTypeName,
          materialTypeName: row.materialTypeName,
          materialTypeId: row.materialTypeId,
          materialTypeNo: row.materialTypeNo,
          materialId: row.materialID,
          materialNo: row.materialNO,
          materialName: row.materialName,
          materialSpecification: row.specification,
          nameplateType: "铭牌",
          quantity: 1,
          price: row.price,
          deliveryDate: "",
          note: row.note,
          measuringUnitID: row.measuringUnitID,
          unitName: row.unitName,
          customerPurchase:"",
          customerContractNoRow:"",
          customerMaterialNo: "",
          customerSpecification: "",
          finalCustomerSpecification: "",
        };
        if (this.sDSalesOrderVO.businessApplicationNo) {
          obj.price = this.businessApplicationPrice;
        }
        this.sDSalesOrderVO.materialVOS.push(obj);
        this.$http
            .post("basic", "sd/so/setPrice", this.sDSalesOrderVO)
            .then((resp) => {
              if (resp.success) {
                resp.data.materialVOS.forEach((item, index) => {
                  this.sDSalesOrderVO.materialVOS[index].standardPrice = item.standardPrice;
                  this.sDSalesOrderVO.materialVOS[index].price = item.price;
                  if (!this.sDSalesOrderVO.materialVOS[index].customerSpecification) {
                    this.sDSalesOrderVO.materialVOS[index].customerSpecification = item.customerSpecification;
                  }
                  if (!this.sDSalesOrderVO.materialVOS[index].customerMaterialNo) {
                    this.sDSalesOrderVO.materialVOS[index].customerMaterialNo = item.customerMaterialNo;
                  }
                });
                this.checkMaterialFirst(obj);
              }
            })
            .catch(() => {
              this.sDSalesOrderVO.materialVOS.splice(this.sDSalesOrderVO.materialVOS.length - 1, 1);
            });
      },

      //校验物料
      checkMaterialFirst(obj) {
        this.$http
            .post("basic", "sd/so/ma/checkMaterial", obj)
            .then((resp) => {
              if (resp.success && resp.data) {
                // this.$message.warning("当前客户首次添加该产品【" + obj.materialNo + "】,请检查是否正确选择产品.");
                this.$confirm("当前客户首次添加该产品【" + obj.materialNo + "】,请检查是否正确选择产品.", "提示", {
                  type: "warning",
                  showCancelButton: false,
                });
              }
            })
            .catch(() => {
            });
      },

      // 上传文件
      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            fileName: fileList[0].name,
            filePath: fileList[0].key,
          };
          this.sDSalesOrderVO.attachments.push(params);
        }
      },

      // 获取订单详情
      getData(salesOrderId) {
        this.contentLoading = true;
        this.$http
            .get("basic", `sd/so/${salesOrderId}`)
            .then((res) => {
              if (res.success) {
                this.sDSalesOrderVO = res.data;
                this.sDSalesOrderVO.districtIdCopy = res.data.districtId.split(",").map((item) => parseInt(item));
                if (this.isCopy) {
                  this.sDSalesOrderVO.salesOrderId = "";
                  this.sDSalesOrderVO.submitDate = "";
                  this.sDSalesOrderVO.erpSalesOrderNo = "";
                }
              }
              this.contentLoading = false;
            })
            .catch(() => {
              this.contentLoading = false;
            });
      },

      businessApplicationAdd() {
        if (this.selection.length === 0) {
          this.$message.error("至少选择一列");
          return;
        }
        let params = {
          materialList: this.selection,
          sDSalesOrderVO: JSON.stringify(this.sDSalesOrderVO),
        };
        this.dialogVisible = false;
        this.$refs.businessApplicationEdit.open(params, 0, 1);
      },

      // 提交
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (!this.sDSalesOrderVO.materialVOS.length) {
              this.$confirm("请添加订单物料!", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            this.sDSalesOrderVO.districtId = this.sDSalesOrderVO.districtIdCopy.join(",");
            this.submitLoading = true;
            // 编辑
            if (this.sDSalesOrderVO.salesOrderId) {
              this.$http
                  .post("basic", "sd/so/update", this.sDSalesOrderVO)
                  .then((res) => {
                    if (res.success) {
                      this.$emit("save-success");
                      this.$message.success("编辑成功");
                      this.dialogVisible = false;
                    }
                    this.submitLoading = false;
                  })
                  .catch(() => {
                    this.submitLoading = false;
                  });
            } else {
              // 新建
              this.$http
                  .post("basic", "sd/so/save", this.sDSalesOrderVO)
                  .then((res) => {
                    if (res.success) {
                      // 关闭标签
                      this.$emit("save-success");
                      this.$message.success("添加成功");
                      this.dialogVisible = false;
                    }
                    this.submitLoading = false;
                  })
                  .catch(() => {
                    this.submitLoading = false;
                  });
            }
          }
        });
      },
    },
  };
</script>

<style lang="scss">
.salesOrderEdit {
  .el-table-column--selection .cell {
    padding-right: 10px;
  }

  .orderMaterials .el-input__inner {
    text-align: center;
  }

  .orderMaterials .note .el-input__inner {
    text-align: left;

  }
}
</style>
